import React from "react";
import rightArrow from "../../images/home/rightArrow.svg";
import SearchJob from "../../images/home/refunds.jpg";
import BestJob from "../../images/home/update.jpg";

const leftData = [
  {
    id: 1,
    name: "part1",
    title: "Save Time & Money",
    text: "Hiring our dedicated remote developers eliminates travel, onboarding delays, and unnecessary overhead costs - giving you faster project starts and better ROI.",
  },
  {
    id: 2,
    name: "part1",
    title: "Out of Box Thinkers",
    text: "Every new developer we onboard brings unique perspectives and problem-solving skills that fuel innovation and strengthen your team’s capabilities.",
  },
  {
    id: 3,
    name: "part1",
    title: "Easy To Manage",
    text: "Our remote developers easily align with your workflows. They're just a message or call away - no micromanagement or complex coordination required.",
  },
  {
    id: 4,
    name: "part2",
    title: "Access to Diverse Technical Expertise",
    text: "With expertise across 20+ technologies, our developers can bridge skill gaps and support your projects with the right solutions - remotely and reliably.",
  },
  {
    id: 5,
    name: "part2",
    title: "Low Cost & Flexible",
    text: "Enjoy reduced hiring costs and a simple, no-strings-attached offboarding process. Get things done without long-term commitments or overhead.",
  },
  {
    id: 6,
    name: "part2",
    title: "Time Zone Compatibility",
    text: "Our developers work in sync with your preferred hours. You’ll always have someone available during critical windows - responsive, trackable, and dependable.",
  },
];

const Team = () => {
  return (
    <>
      <section className="teamSection">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="heading" data-aos="slide-down">
                <h3>
                  Why You Should Hire Remote Developer from{" "}
                  <span>Shine Infosoft?</span>
                </h3>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-12">
              <div
                className="information"
                data-aos="zoom-in"
                style={{ backgroundImage: `url("${BestJob}")` }}
              >
                <div className="row justify-content-end w-100">
                  <div className="col-md-6 col-sm-9">
                    <ul>
                      {leftData.map((m) =>
                        m.name === "part1" ? (
                          <li key={m.id} data-aos="slide-up">
                            <img src={rightArrow} alt="Web App Development" />
                            <h6>{m.title}</h6>
                            <p>{m.text}</p>
                          </li>
                        ) : null
                      )}
                    </ul>
                  </div>
                </div>
              </div>
              <div
                className="information"
                data-aos="zoom-in"
                style={{ backgroundImage: `url("${SearchJob}")` }}
              >
                <div className="row justify-content-start w-100">
                  <div className="col-md-6 col-sm-9">
                    <ul>
                      {leftData.map((m) =>
                        m.name === "part2" ? (
                          <li key={m.id} data-aos="slide-up">
                            <img
                              src={rightArrow}
                              alt="Hire Dedicated Developers"
                            />
                            <h6>{m.title}</h6>
                            <p>{m.text}</p>
                          </li>
                        ) : null
                      )}
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="row align-items-center flex-column-reverse flex-md-row">
            <div className="col-lg-5 col-md-6"></div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Team;
